import * as React from 'React';
import { config } from '../config';
import RequestQuoteWizard from '../../apps/RequestQuote/index';
import RequestService from '../../apps/RequestService';
import AuthRequestQuote from '../../apps/AuthRequestQuote/index';
import SolarCalculator from '../../apps/SolarCalculator';

export type ProjectConfig = {
  [key: string]: React.ComponentClass<any> | React.StatelessComponent<any>;
};

export const apps: ProjectConfig = {
  'auth-quote': AuthRequestQuote,
  calculator: SolarCalculator,
  contact: RequestQuoteWizard,
  quote: RequestQuoteWizard,
  'savings-calculator': SolarCalculator,
  service: RequestService
};

export const getProjectSubDomain = (): string => {
  const solar = window.solar;
  if (solar && solar.context && solar.context !== 'dev') return solar.context;

  if (
    config.ENV === 'local' ||
    config.ENV === 'dev' ||
    config.ENV === 'test' ||
    config.ENV === 'local-test'
  ) {
    const pathname = window.location.pathname.substring(1, window.location.pathname.length);
    const domain = pathname.split('/')[1];
    const route = domain ? domain : pathname;

    if (apps[route]) {
      return route;
    }
  }

  return 'quote';
};
